import { combineReducers } from 'redux';
import marketingMerchantsHomeStores from './marketingMerchantsHomeStores';
import marketingMerchantsHomeTitles from './marketingMerchantsHomeTitles';

export default combineReducers({
  marketingMerchantsHomeTitles,
  marketingMerchantsHomeStores,
});
